<template v-slot="props">
  <div>
    <span class="invisible">{{ task.id }}</span>
    <span v-if="canReadTask">
      <a href="#" title="View/Edit Task" @click.prevent="handleEditTask">{{ getTaskName }}</a>
    </span>
    <span v-else>
      {{ getTaskName }}
    </span>
    <el-tooltip v-if="task.notes" class="item" effect="dark" :content="viewNotesNoHtml" placement="right-end">
      <img class="icon-help m-left-4" src="static/img/icon-info.png" />
    </el-tooltip>
  </div>
</template>
<script>
import Permissions from 'src/utilities/permissions'
import {objectById, stripHTML, taskNameWithOptionalRepeatCountSuffix} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'

export default {
  props: ['data'],
  computed: {
    user() {
      return this.$store.get('security/user')
    },
    userId() {
      return this.$store.get('security/userId')
    },
    task() {
      return this.data
    },
    viewNotesNoHtml() {
      return stripHTML(this.task.notes)
    },
    canReadTask() {
      if (this.$can('read', Permissions.TASKS)) {
        // only let standard users edit their own tasks
        if (objectById(this.user.groups, Constants.GROUPS.STANDARD_USERS)) {
          return this.userId === this.task.assigneeId
        }
        return true
      }
      // users not in a group or no access
      return false
    },
    getTaskName() {
      return taskNameWithOptionalRepeatCountSuffix(this.task)
    },
  },
  methods: {
    handleEditTask() {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: this.task.id})
    },
  }
}
</script>
